import { cn } from "../../../lib/utils/index.js";
import { useGetAssetsAspectRatio } from "../../serverside/getAssetsAspectRatio.js";
import { useEffect } from "react";
import Image from "next/image.js";

export const ImageBlockViewClientside = ({ content }) => {
  return (
    <>
      <div
        className={cn("relative object-cover", {
        })}
        style={{
          width: content.attrs.width || "100%",
        }}
      >
        {/* @ts-ignore */}
        <Image
          className="rounded object-cover"
          src={content.attrs.src}
          alt={content.attrs.alt || content.attrs.caption}
          width={800}
          height={600}
        />
      </div>
      {content.attrs?.caption ? (
        <p
          className={cn(
            "tiptap-image-caption",
            "pt-2 font-sf text-sm font-light text-grey-7 mx-6 sm:mx-0 line-clamp-2"
          )}
        >
          {content.attrs?.caption}
        </p>
      ) : null}
    </>
  );
};
